/**
 * ForknFind's public legal pages on the marketing site. Every "you agree to
 * our Terms / Privacy Policy" line in the dashboard links here, so a change of
 * address only happens once.
 */
export const LEGAL_URLS = {
  terms: 'https://forknfind.com/terms-and-conditions',
  privacy: 'https://forknfind.com/privacy-policy',
} as const;
